import api from '@/api'

export const setData = ({ state, commit }, data) => {
  commit('SET_DATA', data)
}

export const setSchema = ({ state, commit }, schema) => {
  commit('SET_SCHEMA', schema)
}

export const newEntity = ({ state, commit, dispatch, rootGetters }) => {
  let orga = rootGetters['user/selectedOrga']
  let Constructor = state.schema.class
  let blankEntity = new Constructor({ organisationseinheit: orga })
  dispatch('setData', blankEntity)
}

export const closeEditor = ({ state, commit }) => {
  commit('SET_SCHEMA', null)
  commit('SET_DATA', null)
}

export const saveEntity = ({ state, commit, dispatch, rootGetters }) => {
  commit('LOADING_START')

  // set fields that were not visible to null
  for (let bit of state.schema.fields) {
    if (!(bit.view === undefined || bit.view(state.data, rootGetters['user/getUser']))) {
      if (state.data[bit.field] != null) {
        state.data[bit.field] = null
      }
    }
  }

  return api.methods.updaveResource(state.data)
    .then((data) => {
      commit('LOADING_DONE')
      return data
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/creator/actions.js